// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6a80c0f9","341":"bf954bb0","408":"cead93e8","464":"3ec0c686","467":"f1174e1a","483":"a1777649","485":"9a799ff0","664":"aebc33a7","712":"aba5be1b","724":"0c368d23","725":"9dff72f1","896":"ef4bb620","901":"abc52c88","996":"5bd66c8e","999":"9446c16d"}[chunkId] + ".chunk.js";
};